export default __webpack_public_path__ + "static/media/7-choses-à-savoir.db647ea8.jpg";